<template>
  <legal-page>
    <h1>【宇宙之幂】用户服务协议</h1>

    <div class="legal-page__meta">
      <p>更新日期：2026年7月22日</p>
      <p>生效日期：2026年7月22日</p>
    </div>

    <p>宇宙之幂（深圳）科技集团有限公司及其依法设立的关联公司、子公司（以下合称“我司”或“我们”）依据本《【宇宙之幂】用户服务协议》（以下称“本协议”）向使用【宇宙之幂】网站、移动应用程序及相关产品或服务的用户（以下称“您”或“用户”）提供服务。</p>

    <p><strong>请您在注册、登录或使用【宇宙之幂】服务前仔细阅读并充分理解本协议，尤其是以加粗形式提示您注意的关于服务限制、责任承担、账号管理、争议解决等条款。</strong>您点击勾选“我已阅读并同意《用户协议》”、点击登录或以其他明示方式表示同意后，即表示您已阅读、理解并同意接受本协议约束。如果您不同意本协议的任何内容，请停止注册、登录或使用相关服务。</p>

    <section>
      <h2>第一条 协议范围</h2>
      <ol>
        <li>本协议是您与我司之间关于注册、登录、访问和使用【宇宙之幂】服务所订立的协议。</li>
        <li>本协议内容同时包括我司已经发布或将来可能发布并依法向您展示的业务规则、页面说明、操作规范及其他相关规则。相关规则与本协议具有同等效力；如具体业务规则与本协议约定不一致，以具体业务规则为准。</li>
        <li>《【宇宙之幂】隐私保护政策》是本协议的重要组成部分，专门说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您如何行使个人信息相关权利。请您在使用服务前一并阅读。</li>
      </ol>
    </section>

    <section>
      <h2>第二条 账号注册与使用</h2>
      <ol>
        <li>您可以按照页面提示，通过手机号码、验证码、密码、第三方账号或我们支持的其他方式注册、登录和使用服务。您应当提供真实、准确、完整、有效的信息，并在信息发生变化时及时更新。</li>
        <li>您应当妥善保管账号、密码、验证码及其他身份凭证，不得以转让、出租、出借、共享或其他方式允许他人违规使用您的账号。通过您的账号完成的操作，原则上视为您本人实施；如发现账号被盗用、冒用或存在其他安全风险，请立即联系我们。</li>
        <li>因您主动泄露账号信息、将账号交由他人使用或未妥善保管身份凭证造成的损失，由您依法承担相应责任；因我司原因造成的损失，我司依法承担相应责任。</li>
        <li>您不得恶意注册账号，不得利用多个账号实施刷量、欺诈、攻击系统、规避管理措施或其他扰乱平台秩序的行为。</li>
        <li>如法律法规要求对用户进行真实身份认证，您应当按照相关要求提供必要信息。您拒绝提供依法或实现相关服务所必需的信息时，我们可能无法向您提供对应服务。</li>
      </ol>
    </section>

    <section>
      <h2>第三条 服务内容</h2>
      <ol>
        <li>【宇宙之幂】可能向您提供账号服务、智能交互、信息查询、语音输入与播报、内容生成、场景模拟、图像或摄像头扫描、地图展示、定位与导航、音频内容及其他页面实际展示的功能。</li>
        <li>部分功能需要连接互联网，或需要您主动授权录音、摄像头、定位等系统权限。我们将在您使用具体功能时说明权限用途并申请授权。您可以拒绝或撤回相关权限，拒绝或撤回仅影响对应功能的使用。</li>
        <li>为实现部分功能，我们可能依法接入第三方提供的地图、定位、导航、语音、登录、分享或音频服务。第三方服务由相应第三方独立提供，其具体信息和个人信息处理情况以《【宇宙之幂】隐私保护政策》及第三方规则为准。</li>
        <li>我们有权根据业务发展、技术升级、法律法规或监管要求调整、增加、暂停或终止部分服务。涉及用户重大权益的，我们将通过页面提示、公告、消息通知或其他合理方式提前告知，但紧急故障处理、安全风险处置及法律法规另有规定的情形除外。</li>
        <li>您理解并同意，网络服务可能受到网络状况、设备性能、系统维护、第三方服务能力及不可抗力等因素影响。我们将尽合理努力保障服务连续、安全和稳定。</li>
      </ol>
    </section>

    <section>
      <h2>第四条 智能生成与辅助信息特别说明</h2>
      <ol>
        <li>服务中由人工智能、算法模型或第三方数据生成、整理、推荐的文字、语音、图片、路线、数据及其他内容，仅用于为您提供信息和辅助参考，不代表我司作出的专业承诺或保证。</li>
        <li>受技术能力、数据来源和客观条件限制，生成或展示的内容可能存在错误、遗漏、延迟或不适用于特定场景。您应当结合实际情况独立判断并核实重要信息。</li>
        <li>涉及医疗、法律、金融、投资、安全生产、交通出行等可能对人身或财产权益产生重大影响的事项，相关内容不能替代具有相应资质的专业人员意见。您应当咨询专业机构或人员，并遵守现场标识、交通规则及主管部门要求。</li>
        <li>使用地图和导航功能时，您应当以实际道路情况、交通信号、现场标识及交管部门发布的信息为准，不得在驾驶过程中实施妨碍安全驾驶的操作。</li>
      </ol>
    </section>

    <section>
      <h2>第五条 用户行为规范</h2>
      <ol>
        <li>您使用服务时应当遵守中华人民共和国法律法规、公序良俗以及本协议和平台规则，不得利用服务制作、复制、发布、传播、存储或处理违法违规信息。</li>
        <li>您不得利用服务从事危害国家安全、损害公共利益、侵害他人合法权益、实施网络攻击、诈骗、赌博、洗钱、侵犯知识产权、侵犯个人信息权益或其他违法违规活动。</li>
        <li>未经我司书面许可，您不得对服务或相关软件实施反向工程、反向编译、反汇编，不得绕过或破坏技术保护措施，不得通过爬虫、自动化程序、恶意脚本等方式干扰服务正常运行或超出正常使用范围获取数据。</li>
        <li>您通过服务上传、输入、发布或生成的内容不得侵犯任何第三方的知识产权、肖像权、名誉权、隐私权、个人信息权益或其他合法权益。因您提供或使用相关内容引发争议的，您应依法承担相应责任。</li>
        <li>如我们发现或收到举报，认为您的行为可能违反法律法规、本协议或平台规则，我们有权依法采取警示、限制功能、删除违法内容、暂停或终止服务、保存必要记录并向主管部门报告等措施。</li>
      </ol>
    </section>

    <section>
      <h2>第六条 内容及知识产权</h2>
      <ol>
        <li>【宇宙之幂】服务中由我司依法拥有或获得合法授权的软件、程序、界面设计、文字、图片、音视频、商标、标识、数据及其他内容，其知识产权归我司或相关权利人所有。</li>
        <li>未经相关权利人书面许可，您不得擅自复制、修改、传播、出租、出售、发行、公开展示或用于其他商业目的，但法律法规另有规定的除外。</li>
        <li>您对自行上传、输入或依法享有权利的内容保留相应权利。为实现内容存储、展示、转换、传输、生成或向您提供其他指定功能，您同意在提供服务所必需的范围和期限内，授予我们一项非独占、可撤回、免费的使用许可。我们不会超出服务目的使用您的内容；具体个人信息处理规则以隐私保护政策为准。</li>
        <li>如您认为平台内容侵犯您的合法权益，可以通过本协议载明的联系方式向我们提交权利证明和具体请求，我们将在核实后依法处理。</li>
      </ol>
    </section>

    <section>
      <h2>第七条 付费及会员服务</h2>
      <ol>
        <li>部分服务可能采用收费方式。具体服务内容、价格、期限、支付方式、自动续费安排及退款规则，以购买页面、订单页面或专项协议明确展示的内容为准。</li>
        <li>您购买付费服务前，应仔细核对服务名称、账号、期限、价格和适用条件。未成年人进行付费操作应当事先取得监护人同意。</li>
        <li>如相关服务涉及自动续费，我们将在您开通前以显著方式说明扣费规则和关闭方式，并依法向您提供便捷的取消途径。</li>
        <li>因我司原因导致付费服务无法正常提供的，我们将按照法律法规、页面规则及实际情况采取恢复服务、延长服务期限、退款或其他合理措施。</li>
      </ol>
    </section>

    <section>
      <h2>第八条 个人信息保护</h2>
      <ol>
        <li>我们重视对用户个人信息和隐私的保护，并将按照法律法规及《【宇宙之幂】隐私保护政策》处理您的个人信息。</li>
        <li>我们不会因您拒绝提供非必要个人信息或拒绝授予非必要系统权限，而拒绝您使用与该信息或权限无关的基本功能。</li>
        <li>您可以按照隐私保护政策载明的方式查询、更正、复制、删除个人信息，撤回同意或申请注销账号。撤回同意不影响撤回前基于您同意已进行的个人信息处理活动的效力。</li>
      </ol>
    </section>

    <section>
      <h2>第九条 服务中断、责任承担与免责范围</h2>
      <ol>
        <li>我们将按照法律法规要求采取合理措施保障服务安全稳定，但不能保证服务在任何时间、任何地区、任何网络和设备环境下均不会发生中断、延迟、错误或安全风险。</li>
        <li>因自然灾害、公共卫生事件、政府行为、法律政策变化、战争、通信线路故障、网络攻击、第三方服务中断或其他不可预见、不可避免且不可克服的事件导致服务无法正常提供的，各方按照法律规定承担相应责任。我们将尽合理努力降低由此造成的影响。</li>
        <li>对于第三方独立提供的产品或服务，您还应遵守第三方协议。因第三方原因产生的问题，由责任方依法承担责任；我们将依法在必要范围内协助您处理相关问题。</li>
        <li>本协议中的任何约定均不排除或限制我司依法应当承担的责任，也不影响您作为消费者依法享有的权利。</li>
      </ol>
    </section>

    <section>
      <h2>第十条 服务暂停、终止与账号注销</h2>
      <ol>
        <li>您可以停止使用服务，并可以按照应用内指引或隐私保护政策载明的方式申请注销账号。</li>
        <li>如您严重违反法律法规、本协议或平台规则，或者您的行为对平台、其他用户或第三方造成现实风险，我们可以依法暂停或终止向您提供全部或部分服务，并在合理范围内向您说明原因。</li>
        <li>服务终止或账号注销后，我们将依照法律法规及隐私保护政策处理账号信息和相关数据。法律法规要求保存的信息，我们将在法定期限和目的范围内继续保存，并采取必要保护措施。</li>
      </ol>
    </section>

    <section>
      <h2>第十一条 未成年人保护</h2>
      <ol>
        <li>如您未满十八周岁，应当在父母或其他监护人的陪同和指导下阅读本协议，并在取得监护人同意后使用服务。</li>
        <li>未满十四周岁的未成年人使用涉及个人信息处理的服务，应当由其父母或其他监护人阅读并同意专门的未成年人个人信息处理规则；在未取得监护人同意前，请勿提供相关个人信息。</li>
        <li>监护人应当合理引导未成年人使用网络服务，关注其账号安全、消费行为及使用内容。如监护人对未成年人使用服务存在疑问，可以通过本协议载明的方式联系我们。</li>
      </ol>
    </section>

    <section>
      <h2>第十二条 协议更新</h2>
      <ol>
        <li>我们可能根据业务调整、技术变化、法律法规或监管要求更新本协议。</li>
        <li>如更新内容可能对您的权益产生重大影响，我们将通过应用内弹窗、页面提示、公告或其他显著方式向您说明。依法需要重新取得同意的，我们将在取得您的明确同意后实施相关处理或继续提供对应服务。</li>
        <li>如您不同意更新后的协议，可以停止使用服务并申请注销账号；如您在完成必要提示和确认后继续使用服务，视为您接受更新后的协议。</li>
      </ol>
    </section>

    <section>
      <h2>第十三条 法律适用与争议解决</h2>
      <ol>
        <li>本协议的订立、生效、履行、解释及争议解决适用中华人民共和国大陆地区法律，但法律另有强制性规定的除外。</li>
        <li>因本协议或使用服务产生争议的，双方应首先友好协商解决；协商不成的，任何一方均可依法向有管辖权的人民法院提起诉讼。</li>
        <li>本协议部分条款被认定为无效或无法执行的，不影响其他条款的效力。</li>
      </ol>
    </section>

    <section>
      <h2>第十四条 如何联系我们</h2>
      <p>如您对本协议、账号、服务或消费者权益保护事项有任何问题、意见或建议，可以发送邮件至 <a href="mailto:universepower@universepower.cn">universepower@universepower.cn</a> 与我们联系。我们将在收到您的反馈并核验必要信息后，在法律法规规定的期限内予以处理。</p>
    </section>

    <p>请您再次确认，您已完整阅读、充分理解并同意本协议全部内容。</p>
  </legal-page>
</template>

<script>
import LegalPage from '@/components/main/legal/LegalPage'

export default {
  name: 'UserAgreement',
  components: {
    LegalPage
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/userAgreement.vue